export const PASSWORD_MIN_LENGTH = 12;

// Keep in sync with PASSWORD_POLICY_REGEX in apps/saas_back/src/models/user.ts.
const PASSWORD_POLICY_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&+=.:/?<>_-]).{12,}$/;

const validatePassword = (password: string, email: string) => {
  if (email !== '' && password.includes(email)) {
    return false;
  }
  return PASSWORD_POLICY_REGEX.test(password);
};

export const getPasswordErrorMessage = (password: string, email: string) => {
  if (email !== '' && password.includes(email)) {
    return 'Por favor, no ocupes tu email como contraseña 😬';
  }
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Te faltan ingresar ${PASSWORD_MIN_LENGTH - password.length} caracteres 😓`;
  }
  if (!/[a-z]/.test(password)) {
    return 'La contraseña debe contener al menos una letra minúscula 🔡';
  }
  if (!/[A-Z]/.test(password)) {
    return 'La contraseña debe contener al menos una letra mayúscula 🔠';
  }
  if (!/\d/.test(password)) {
    return 'La contraseña debe contener al menos un número 🔢';
  }
  if (!/[!@#$%^&+=.:/?<>_-]/.test(password)) {
    return 'La contraseña debe contener al menos un carácter especial (!@#$%^&+=.:/?<>_-) 🔣';
  }
  return '';
};

export default validatePassword;
